module.exports = __webpack_public_path__ + "img/3_002.84115b68.webp";